import api from '../../api/http-common'

export const getFarmerGroupsList = (module?, search?, data?) =>
  api.post('/farmer-groups/list', { module: module || '', search: search || '', ...data })

const farmerGroupsWithModulesList = (module?, search?, data?) =>
  api.post('/farmer-groups/list', { modules: module || '', search: search || '', ...data })

const getFarmerGroupsInfo = (search?, data?) =>
  api.post('farmer-groups/climate-check/list ', { search: search || '', ...data })

export const getFarmerGroupsListOrganization = (isOrganization?) =>
  api.post('/farmer-groups/list', { isOrganization: isOrganization || '' })

const getFarmerGroupsOptionsData = (): any =>
  api.post('/farmer-groups/get-options-data')

const getFarmerGroupsIndex = (data?): any => {
  return api.post('/farmer-groups/index', data)
}

const createFarmerGroup = (data?): any => {
  return api.post('/farmer-groups/store', data)
}

const updateFarmerGroup = (id: string, data?): any => {
  return api.post(`/farmer-groups/${id}/update`, data)
}

const getFarmerGroup = (id: string): any => {
  return api.post(`/farmer-groups/${id}/edit`)
}

const showFarmerGroup = (id: string): any => {
  return api.post(`/farmer-groups/${id}/show`)
}

const deleteFarmerGroup = (id: string): any => {
  return api.post(`/farmer-groups/${id}/delete`)
}

const blockFarmerGroup = (id: string): any => {
  return api.post(`/farmer-groups/${id}/block`)
}

const unblockFarmerGroup = (id: string): any => {
  return api.post(`/farmer-groups/${id}/unblock`)
}

const checkFarmerGroupName = (data) =>
  api.post('/farmer-groups/check-name', data)

const FarmerGroupsService = {
  getFarmerGroupsList,
  getFarmerGroupsOptionsData,
  getFarmerGroupsIndex,
  createFarmerGroup,
  updateFarmerGroup,
  getFarmerGroup,
  showFarmerGroup,
  blockFarmerGroup,
  unblockFarmerGroup,
  checkFarmerGroupName,
  getFarmerGroupsListOrganization,
  deleteFarmerGroup,
  farmerGroupsWithModulesList,
  getFarmerGroupsInfo
}

export default FarmerGroupsService
